module.exports = __webpack_public_path__ + "static/media/caetano_auto.e5626a79.webp";